import { render } from "./OnlineConsultation.vue?vue&type=template&id=358bbf05"
import script from "./OnlineConsultation.vue?vue&type=script&lang=js"
export * from "./OnlineConsultation.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__